<template>
<ItpPage
  card
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="Worksheet"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :color="$config.worksheet.color"
    slot="header"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
  >
    <UcWorksheetHeader
      :worksheet="item"
      @reload="evh_8564662037462133_reload($event, {})"
      @deleted="evh_8564662037462133_deleted($event, {})"
    >
    </UcWorksheetHeader>
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    v-if="loaded"
  >
    <ItpForm
      :id="formId"
      name="worksheet"
      autofocus="first"
      v-if="isNew"
      @submit="evh_1040167445267876_submit($event, {})"
    >
      <ItpCol>
        <UcWorksheetEditorFieldset
          :worksheet="item"
        >
        </UcWorksheetEditorFieldset>
      </ItpCol>
    </ItpForm>
    <ItpPanel
      collapsible
      :caption="'Worksheet data'|pgettext('Worksheet')"
      carousel
      v-if="!isNew"
    >
      <UcWorksheetData
        :worksheet="item"
        :formId="formId"
        :reload="lastLoaded"
        class="pt-3"
        @reload="evh_1468474219929533_reload($event, {})"
      >
      </UcWorksheetData>
    </ItpPanel>
    <hr
      v-if="!isNew"
    >
    </hr>
    <DIV
      class="overflow-hidden w-100"
      v-if="!isNew"
    >
      <UcWorksheetWorkItems
        :worksheet="item"
        :isReadonly="isReadonly"
        :reload="lastLoaded"
        class="h-100 w-100"
        @reload="evh_1306227577716690_reload($event, {})"
      >
      </UcWorksheetWorkItems>
    </DIV>
    <hr
      v-if="!isNew"
    >
    </hr>
    <DIV
      class="overflow-hidden w-100"
      v-if="!isNew"
    >
      <UcWorksheetInvoiceLineAccountings
        :worksheet="item"
        :isReadonly="isReadonly"
        :reload="lastLoaded"
        class="h-100 w-100"
        @reload="evh_8723442106880637_reload($event, {})"
      >
      </UcWorksheetInvoiceLineAccountings>
    </DIV>
  </UcBody>
  <UcFooter
    :card="!modal"
    :modal="modal"
    :color="$config.payment.color"
    slot="footer"
    v-if="loaded"
  >
    <ItpButton
      :text="'Create worksheet'|pgettext('Button')"
      type="submit"
      :form="forms.worksheet"
      variant="primary"
      :spinning="actions.save.isRunning"
      class="mr-2"
      v-if="isNew"
    >
    </ItpButton>
  </UcFooter>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

addRoute(
  {
    name: "worksheet",
    path: "/worksheets/:id",
    component: "Worksheet",
    params: [{
      name: "id",
      prop: "oid",
    }
      ,
    ]

  }
)

@Component()
export default class Worksheet extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  @Prop({
    type: String,
  })
  oid!: string;

  @Watch('oid')
  onOid(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("oid")
  }

  @Prop({
    type: String,
    default: function() {
      return this.$fn.randomElementId()
    },
  })
  formId!: string;

  @Watch('formId')
  onForm_id(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("formId")
  }

  @Prop({
    type: String,
    default: "full-screen",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  item!: any;

  async $$load_item() {
    return (this.oid === 'create' || this.oid == null)
      ? this.$fn.fetch('get_worksheet_template', { asResource: true })
      : this.$fn.fetch('read_worksheet', { parameters: { id: this.oid }, asResource: true })
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  dataMembers = ['item', 'ux', 'b_7315092382398562_modalBindings'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        item: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "full-screen",
        }
        ,
      },
    }
  }

  get isNew() {
    if (this.loaded) {

      return this.item.isNew
    }
    return null;
  }

  get isReadonly() {
    if (this.loaded) {

      return false
    }
    return null;
  }

  get document() {
    if (this.loaded) {

      return {
        title: [this.item.snapshot('number')
          ,
        this.$fn.gettext("Worksheet")
          ,
        ]
        ,
        icon: this.$config.worksheet.icon,
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_5696_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_5696, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async evh_8564662037462133_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8564662037462133_reload.executeFromDOM(this, event, scope);
  }

  async act_8564662037462133_reloadSlickgrid_5704_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_8564662037462133_reloadSlickgrid_5704, alias=undefined
    return {
      grid: "worksheets",
    }
  }

  async evh_8564662037462133_deleted(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8564662037462133_deleted.executeFromDOM(this, event, scope);
  }

  async act_1040167445267876_reloadSlickgrid_5708_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_1040167445267876_reloadSlickgrid_5708, alias=undefined
    return {
      grid: "worksheets",
    }
  }

  async evh_1040167445267876_success_5707_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_1040167445267876_success_5707, alias=undefined
    return this.item.id
  }

  async act_1040167445267876_closeComponent_5710_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseComponentActionArgs> {
    // parameterResolver name=act_1040167445267876_closeComponent_5710, alias=undefined
    return {
      result: {
        close: true,
      }
      ,
    }
  }

  async evh_1040167445267876_success_5709_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_1040167445267876_success_5709, alias=undefined
    return !this.item.id
  }

  async act_1040167445267876_navigate_5712_getActionArgs($event: actions.ActionEvent): Promise<actions.NavigateActionArgs> {
    // parameterResolver name=act_1040167445267876_navigate_5712, alias=undefined
    return {
      location: {
        name: "app.worksheet",
        params: {
          id: $event.data.id,
        }
        ,
      }
      ,
    }
  }

  async evh_1040167445267876_success_5711_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_1040167445267876_success_5711, alias=undefined
    return !this.item.id
  }

  async act_1040167445267876_setData_5714_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_1040167445267876_setData_5714, alias=undefined
    return {
      path: "item",
      value: $event.data,
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async evh_1040167445267876_success_5713_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_1040167445267876_success_5713, alias=undefined
    return this.item.id && !!$event.data && !!$event.data.id
  }

  async act_1040167445267876_form_5716_getActionArgs($event: actions.ActionEvent): Promise<actions.FormActionArgs> {
    // parameterResolver name=act_1040167445267876_form_5716, alias=undefined
    return {
      name: this.formId,
      reset: true,
    }
  }

  async evh_1040167445267876_success_5715_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_1040167445267876_success_5715, alias=undefined
    return this.item.id && !!$event.data && !!$event.data.id
  }

  async act_1040167445267876_crud_5706_getActionArgs($event: actions.ActionEvent): Promise<actions.CRUDActionArgs> {
    // parameterResolver name=act_1040167445267876_crud_5706, alias=save
    return {
      objectType: "worksheet",
      op: "upsert",
      data: this.item,
    }
  }

  async evh_1040167445267876_submit(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
  }

  async evh_1468474219929533_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1468474219929533_reload.executeFromDOM(this, event, scope);
  }

  async evh_1306227577716690_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1306227577716690_reload.executeFromDOM(this, event, scope);
  }

  async evh_8723442106880637_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8723442106880637_reload.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_5696: actions.CloseModalAction;
    evh_7315092382398562_close_5695: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeModal_5698: actions.CloseModalAction;
    evh_2248226175642056_close_5697: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_8564662037462133_reloadComponentData_5700: actions.ReloadComponentDataAction;
    evh_8564662037462133_reload_5699: actions.EventHandlerImpl;
    evh_8564662037462133_reload: actions.EventHandlerGroup;
    act_8564662037462133_closeModal_5702: actions.CloseModalAction;
    evh_8564662037462133_deleted_5701: actions.EventHandlerImpl;
    act_8564662037462133_reloadSlickgrid_5704: actions.ReloadSlickgridAction;
    evh_8564662037462133_deleted_5703: actions.EventHandlerImpl;
    evh_8564662037462133_deleted: actions.EventHandlerGroup;
    act_1040167445267876_reloadSlickgrid_5708: actions.ReloadSlickgridAction;
    evh_1040167445267876_success_5707: actions.EventHandlerImpl;
    act_1040167445267876_closeComponent_5710: actions.CloseComponentAction;
    evh_1040167445267876_success_5709: actions.EventHandlerImpl;
    act_1040167445267876_navigate_5712: actions.NavigateAction;
    evh_1040167445267876_success_5711: actions.EventHandlerImpl;
    act_1040167445267876_setData_5714: actions.SetDataAction;
    evh_1040167445267876_success_5713: actions.EventHandlerImpl;
    act_1040167445267876_form_5716: actions.FormAction;
    evh_1040167445267876_success_5715: actions.EventHandlerImpl;
    act_1040167445267876_crud_5706: actions.CRUDAction;
    evh_1040167445267876_submit_5705: actions.EventHandlerImpl;
    evh_1040167445267876_submit: actions.EventHandlerGroup;
    act_1468474219929533_reloadComponentData_5718: actions.ReloadComponentDataAction;
    evh_1468474219929533_reload_5717: actions.EventHandlerImpl;
    evh_1468474219929533_reload: actions.EventHandlerGroup;
    act_1306227577716690_reloadComponentData_5720: actions.ReloadComponentDataAction;
    evh_1306227577716690_reload_5719: actions.EventHandlerImpl;
    evh_1306227577716690_reload: actions.EventHandlerGroup;
    act_8723442106880637_reloadComponentData_5722: actions.ReloadComponentDataAction;
    evh_8723442106880637_reload_5721: actions.EventHandlerImpl;
    evh_8723442106880637_reload: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_5696 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_5696_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_5695 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_5696,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_5695],
      }
    );
    const act_2248226175642056_closeModal_5698 = new actions.CloseModalAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_5697 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeModal_5698,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_5697],
      }
    );
    const act_8564662037462133_reloadComponentData_5700 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_8564662037462133_reload_5699 = new actions.EventHandlerImpl(
      {
        action: act_8564662037462133_reloadComponentData_5700,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_8564662037462133_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_8564662037462133_reload_5699],
      }
    );
    const act_8564662037462133_closeModal_5702 = new actions.CloseModalAction(
      {
        events: [],
      }
    );
    const evh_8564662037462133_deleted_5701 = new actions.EventHandlerImpl(
      {
        action: act_8564662037462133_closeModal_5702,
        event: "deleted",
        displayName: "closeModal",
      }
    );
    const act_8564662037462133_reloadSlickgrid_5704 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_8564662037462133_reloadSlickgrid_5704_getActionArgs,
        events: [],
      }
    );
    const evh_8564662037462133_deleted_5703 = new actions.EventHandlerImpl(
      {
        action: act_8564662037462133_reloadSlickgrid_5704,
        event: "deleted",
        displayName: "reloadSlickgrid",
      }
    );
    const evh_8564662037462133_deleted = new actions.EventHandlerGroup(
      {
        handlers: [evh_8564662037462133_deleted_5701, evh_8564662037462133_deleted_5703],
      }
    );
    const act_1040167445267876_reloadSlickgrid_5708 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_1040167445267876_reloadSlickgrid_5708_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_success_5707 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_reloadSlickgrid_5708,
        event: "success",
        when: this.evh_1040167445267876_success_5707_getWhen,
        displayName: "reloadSlickgrid",
      }
    );
    const act_1040167445267876_closeComponent_5710 = new actions.CloseComponentAction(
      {
        actionArgs: this.act_1040167445267876_closeComponent_5710_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_success_5709 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_closeComponent_5710,
        event: "success",
        when: this.evh_1040167445267876_success_5709_getWhen,
        displayName: "closeComponent",
      }
    );
    const act_1040167445267876_navigate_5712 = new actions.NavigateAction(
      {
        actionArgs: this.act_1040167445267876_navigate_5712_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_success_5711 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_navigate_5712,
        event: "success",
        when: this.evh_1040167445267876_success_5711_getWhen,
        displayName: "navigate",
      }
    );
    const act_1040167445267876_setData_5714 = new actions.SetDataAction(
      {
        actionArgs: this.act_1040167445267876_setData_5714_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_success_5713 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_setData_5714,
        event: "success",
        when: this.evh_1040167445267876_success_5713_getWhen,
        displayName: "setData",
      }
    );
    const act_1040167445267876_form_5716 = new actions.FormAction(
      {
        actionArgs: this.act_1040167445267876_form_5716_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_success_5715 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_form_5716,
        event: "success",
        when: this.evh_1040167445267876_success_5715_getWhen,
        displayName: "form",
      }
    );
    const act_1040167445267876_crud_5706 = new actions.CRUDAction(
      {
        actionArgs: this.act_1040167445267876_crud_5706_getActionArgs,
        displayName: "save",
        events: [evh_1040167445267876_success_5707, evh_1040167445267876_success_5709, evh_1040167445267876_success_5711, evh_1040167445267876_success_5713, evh_1040167445267876_success_5715],
      }
    );
    const evh_1040167445267876_submit_5705 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_crud_5706,
        event: "submit",
        displayName: "save",
      }
    );
    const evh_1040167445267876_submit = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_submit_5705],
      }
    );
    const act_1468474219929533_reloadComponentData_5718 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_1468474219929533_reload_5717 = new actions.EventHandlerImpl(
      {
        action: act_1468474219929533_reloadComponentData_5718,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_1468474219929533_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_1468474219929533_reload_5717],
      }
    );
    const act_1306227577716690_reloadComponentData_5720 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_1306227577716690_reload_5719 = new actions.EventHandlerImpl(
      {
        action: act_1306227577716690_reloadComponentData_5720,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_1306227577716690_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_1306227577716690_reload_5719],
      }
    );
    const act_8723442106880637_reloadComponentData_5722 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_8723442106880637_reload_5721 = new actions.EventHandlerImpl(
      {
        action: act_8723442106880637_reloadComponentData_5722,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_8723442106880637_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_8723442106880637_reload_5721],
      }
    );
    return {
      act_7315092382398562_closeModal_5696,
      evh_7315092382398562_close_5695,
      evh_7315092382398562_close,
      act_2248226175642056_closeModal_5698,
      evh_2248226175642056_close_5697,
      evh_2248226175642056_close,
      act_8564662037462133_reloadComponentData_5700,
      evh_8564662037462133_reload_5699,
      evh_8564662037462133_reload,
      act_8564662037462133_closeModal_5702,
      evh_8564662037462133_deleted_5701,
      act_8564662037462133_reloadSlickgrid_5704,
      evh_8564662037462133_deleted_5703,
      evh_8564662037462133_deleted,
      act_1040167445267876_reloadSlickgrid_5708,
      evh_1040167445267876_success_5707,
      act_1040167445267876_closeComponent_5710,
      evh_1040167445267876_success_5709,
      act_1040167445267876_navigate_5712,
      evh_1040167445267876_success_5711,
      act_1040167445267876_setData_5714,
      evh_1040167445267876_success_5713,
      act_1040167445267876_form_5716,
      evh_1040167445267876_success_5715,
      act_1040167445267876_crud_5706,
      evh_1040167445267876_submit_5705,
      evh_1040167445267876_submit,
      act_1468474219929533_reloadComponentData_5718,
      evh_1468474219929533_reload_5717,
      evh_1468474219929533_reload,
      act_1306227577716690_reloadComponentData_5720,
      evh_1306227577716690_reload_5719,
      evh_1306227577716690_reload,
      act_8723442106880637_reloadComponentData_5722,
      evh_8723442106880637_reload_5721,
      evh_8723442106880637_reload,
      save: act_1040167445267876_crud_5706,
    }
  }
}

Vue.component("Worksheet", Worksheet);

</script>